export enum Strings {
    UID = 'uid',
    TABS = '/tabs',
    LOGIN = '/login',
    ADMIN = '/admin',
    TYPE = 'user',
    USER_PROFILE = 'user_profile' // Added key for user profile storage
}
